import type { FC } from "react";

import { Overview as UIOverview } from "@jti/loyalty/components/Overview";

import type { overviewInputs } from "./Overview.builder";

export type OverviewBuilderProps = BuilderComponentProps<typeof overviewInputs>;

export const Overview: FC<OverviewBuilderProps> = ({ variant, title, subtitle, secondarySubtitle, items = [] }) => {
  return (
    <UIOverview
      variant={variant}
      title={title}
      subtitle={subtitle}
      secondarySubtitle={secondarySubtitle}
      items={items}
    />
  );
};
